import React, { Component } from 'react'

const type = localStorage.getItem("type");



class Addproductbutton extends Component {
    onFormSubmit(event)
    {
      event.preventDefault();
        window.location.replace("/addproduct");
        
    }

	render() {
        if (type === "boss"){
            return (
                <div>
               <form onSubmit={this.onFormSubmit}  id="allbutton" >
                 <div>
                 
                    <button class="btn btn-dark button2 "  >
                   
                        Add New Product
                      </button>
                      
                      </div>
                    </form>
              </div>
              
            )
        }
		
	}
}

export default Addproductbutton